import { urls } from 'Src/constants/Urls'
import { axiosDS, getBaseUrl } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { ResetPasswordByTokenModel, AuthLoginModel, AuthTokenModel, Auth } from 'Pages/auth'
import { PartnerPaymentModel } from 'Models'

export const authApi = {
	loginAs: async (userId: number | string) => {
		const url = urls.auth.loginAs.replace(':userId', userId.toString())
		const res = await axiosDS().get<AuthTokenModel>(url)
		return res.data
	},

	userLogin: async (data: AuthLoginModel) => {
		const extendHeaders = {
			'Screen-Resolution': `${window.screen.availWidth} x ${window.screen.availHeight}`,
			'Viewport-Resolution': `${window.innerWidth} x ${window.innerHeight}`,
			'Device-Pixel-Ratio': `${window.devicePixelRatio}`,
			AuthHost: getBaseUrl(),
		}
		const res = await axiosDS({ extendHeaders }).post<AuthTokenModel>(urls.auth.login, { data })
		return res.data
	},

	getUser: async (id: number | string) => {
		const res = await axiosDS().get<Auth>(`${urls.common.catalogs.user}/${id}`)
		return res.data
	},

	updateUser: async (data: Partial<Auth>) => {
		const res = await axiosDS().patch<Auth>(urls.users.index.replace(':id', data.id.toString()), {
			data,
		})
		return res.data
	},

	updatePartnerPayment: async (data: PartnerPaymentModel) => {
		const res = await axiosDS().patch<PartnerPaymentModel>(
			`${urls.common.partner_payment}/${data.id}`,
			{ data }
		)
		return res.data
	},

	resetPassword: async (data: { email: string; response: string }) => {
		const res = await axiosDS().post<SimpleResponse>(urls.auth.reset_password, { data })
		return res.data
	},

	resetPasswordByToken: async (data: ResetPasswordByTokenModel) => {
		const res = await axiosDS().post<AuthTokenModel>(urls.auth.reset_password_by_token, { data })
		return res.data
	},

	refreshPassword: async (data: {
		old_password: string
		username: string
		password: string
		confirm_password: string
	}) => {
		const res = await axiosDS().patch<AuthTokenModel>(urls.auth.refresh_password, { data })
		return res.data
	},

	getCheckUser: async (partner_id: number, params) => {
		const res = await axiosDS().get<PartnerPaymentModel>(`${urls.auth.check_user}/${partner_id}`, {
			params,
		})
		return res.data
	},
}
